import { createRouter, createWebHistory } from 'vue-router'
import { SsoRedirectHandler } from '@/lib'
import RootComponent from '../components/RootComponent.vue'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'RootComponent',
      component: RootComponent
    },
    {
      path: '/getting-started',
      name: 'GettingStartedComponent',
      component: () => import('../components/GettingStartedComponent.vue')
    },
    {
      path: '/auth',
      name: 'TokenRedirect',
      component: () => import('../components/TokenComponent.vue'),
      props: true
    },
    {
      path: '/titles',
      name: 'TitlesComponent',
      component: () => import('../components/TitlesComponent.vue'),
    },
    {
      path: '/titles/:id',
      name: 'TitleFormComponent',
      component: () => import('../components/TitleFormComponent.vue')
    },
    {
      path: '/quests',
      name: 'QuestsComponent',
      component: () => import('../components/QuestsComponent.vue'),
      props: { isTarget: false }
    },
    {
      path: '/quests/:id',
      name: 'QuestFormComponent',
      component: () => import('../components/QuestFormComponent.vue'),
      props: { isTarget: false }
    },
    {
      path: '/quests/targeted',
      name: 'QuestsTargetedComponent',
      component: () => import('../components/QuestsTargetedComponent.vue'),
      props: { isTarget: true }
    },
    {
      path: '/quests/targeted/:id',
      name: 'QuestTargetFormComponent',
      component: () => import('../components/QuestFormComponent.vue'),
      props: { isTarget: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/auth') {
    return next()
  }
  if (SsoRedirectHandler.verifyAuth()) {
    next()
  }
 })

export default router
